import bem from 'utils/bem';

export const block = bem('claim-podcasts-banner');
